<header>
    <div class="left">
        <button mat-button routerLink="/"><mat-icon>arrow_back</mat-icon> Dashboard</button>
    </div>

    <div class="right">
        <button (click)="payPayroll()" color="primary" mat-raised-button>Pay Payroll</button>
        <button (click)="report()" color="primary" mat-raised-button>Report</button>
        <a target="_blank" href="https://onlineservices.ato.gov.au/business/" mat-raised-button>ATO Online Services</a>
    </div>
</header>

<div class="tabs">
    <div class="left">
        <ng-container *ngIf="dateMode != DateMode.Custom">
            <button [disabled]="isLoading || isPreviousDateRangeDisabled()" mat-button (click)="previousDateRange()">{{getLabel()[0]}}</button>
            <button [disabled]="isLoading" *ngIf="dateOffset > 0" mat-button (click)="nextDateRange()">{{getLabel()[1]}}</button>
        </ng-container>
        <ng-container *ngIf="dateMode == DateMode.Custom">
            <button mat-button (click)="cancelCustom()">Cancel</button>
        </ng-container>
    </div>

    <div class="center">
        <div class="preset-toolbar">
          <!-- <mat-form-field appearance="outline" class="preset-select">
            <mat-label>Preset</mat-label>
            <mat-select [(value)]="selectedPresetName">
              <mat-option *ngFor="let preset of transactionPresets" [value]="preset.name">
                {{ preset.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <button mat-raised-button color="primary" (click)="applyPresetToFiltered()" [disabled]="!canApplyPreset()">
            Apply to {{ dataSource?.filteredData?.length || 0 }} {{ dataSource?.filteredData?.length === 1 ? 'transaction' : 'transactions' }}
          </button> -->
          <button mat-stroked-button color="primary" *ngIf="canAutoSortTransactions()" (click)="useBusinessPreset()" [disabled]="isApplyingPreset">
            Use {{ activeExpenseCategory }} preset
          </button>
          <button mat-button (click)="openPresetManager()">Manage presets</button>
          <button type="button" mat-stroked-button [color]="showIgnoredTransactions ? 'primary' : undefined" [class.active]="showIgnoredTransactions" [attr.aria-pressed]="showIgnoredTransactions" (click)="toggleIgnoredTransactions()">
            Ignored transactions: {{ showIgnoredTransactions ? 'On' : 'Off' }}
          </button>
        </div>
    </div>

    <!-- <div class="center">
        <button *ngIf="dateMode != DateMode.Custom" mat-button [matMenuTriggerFor]="menu2">BAS Ranges</button>
        <button *ngIf="dateMode == DateMode.Custom" mat-button [matMenuTriggerFor]="menu2">{{customDateRange.label}}</button>
    </div> -->

    <div class="date-range-colume">
        <mat-menu #menu2="matMenu">
            <button (click)="switchToCustomDateRange(range)" *ngFor="let range of basDateRanges" mat-menu-item>{{range.label}}</button>
        </mat-menu>

        <button mat-button [matMenuTriggerFor]="menu">{{this.dateRange.start | date}} to {{this.dateRange.end | date}}</button>
        <mat-menu #menu="matMenu">
            <button (click)="switchToWeekly()" mat-menu-item>Weekly</button>
            <button (click)="switchToMonthly()" mat-menu-item>Monthly</button>
            <button (click)="switchToQuaterly()" mat-menu-item>Quaterly</button>
            <button (click)="switchToYearly()" mat-menu-item>Yearly</button>
            <button (click)="switchToAllTime()" mat-menu-item>All Time</button>
        </mat-menu>
    </div>
</div>

<div class="container">
    <div class="left">
        <button [class.active]="activeCategory=='accounts'" mat-button (click)="loadBooks('accounts')">Accounts</button>
        <button [class.active]="activeCategory=='overview'" mat-button (click)="loadBooks('overview')">Overview</button>
        <button class="tabbed" [class.active]="activeCategory=='payroller-summary'" mat-button (click)="loadBooks('payroller-summary')">Financial Summary</button>
        <button [class.active]="activeCategory=='revenue'" mat-button (click)="loadBooks('revenue')">Revenue</button>
        <!-- <button [class.active]="activeCategory=='pending-revenue'" mat-button (click)="switchCategoryPendingRevenue()">Pending Revenue</button> -->
        <!-- <button [class.active]="activeCategory=='wages'" mat-button (click)="loadBooks('wages')">Wages</button> -->
        <button [class.active]="activeCategory=='expenses' && activeExpenseCategory == ''" mat-button (click)="loadBooks('expenses')">Expenses</button>

        <!-- <ng-container *ngFor="let category of atoCategorieTotals">
            <button class="tabbed" [title]="category.label" [class.active]="activeExpenseCategory==category.category" (click)="loadBooks('expenses-ato', category.category)" mat-button>{{category.label}} ({{category.count}})</button>
        </ng-container> -->

        <button class="tabbed" title="Uncategorised" [class.active]="activeExpenseCategory=='uncategorized'" (click)="loadBooks('expenses-business', 'uncategorized')" mat-button>Uncategorized</button>
        <ng-container *ngFor="let category of getAlphabetical(expensesCategorisedBusiness)">
            <button class="tabbed" [title]="category.label" [class.active]="activeExpenseCategory==category.label" (click)="loadBooks('expenses-business', category.label)" mat-button>{{category.label}} ({{category.transactions.length}})</button>
        </ng-container>

    </div>


    <div class="right transactionPanel">

        <div class="stats" *ngIf="showStats()">
            <div>
                Viewing
                <p>{{info.count}}</p>
            </div>
            <div>
                Total
                <p>{{info.amount | human:true}}<br></p>
            </div>
            <div>
                GST
                <p>{{info.vat | human:true}}</p>
            </div>
            <div>
                Net GST
                <p>{{info.netGST | human:true}}<br></p>
            </div>
            <div class="search">
                <div class="search-controls">
                    <ap-search
                      [query]="currentSearchQuery"
                      (onChange)="search($event)"
                      (cancelled)="searchCancelled()"
                      [alignRight]="true"></ap-search>
                </div>
            </div>
        </div>

        <div class="overview-panel" *ngIf="activeCategory=='accounts'">

            <div class="table">
                <div class="header row">
                    <div></div>
                    <div class="align-right"></div>
                    <div class="align-right"></div>
                    <div class="align-right">Net Amount</div>
                </div>
                <div class="row" (click)="switchCategoryExpense()">
                    <div>Expenses</div>
                    <div class="align-right"></div>
                    <div class="align-right"></div>
                    <div class="align-right">{{accountExpensesAmount | human:true}}</div>
                </div>
                <div class="row" (click)="switchCategoryRevenue()">
                    <div>Revenue</div>
                    <div class="align-right"></div>
                    <div class="align-right"></div>
                    <div class="align-right">{{accountRevenueAmount | human:true}}</div>
                </div>
                <div class="row" (click)="switchCategoryRevenue()">
                    <div>Wages</div>
                    <div class="align-right"></div>
                    <div class="align-right"></div>
                    <div class="align-right">{{wagesRevenueAmount | human:true}}</div>
                </div>
                <div class="row" (click)="switchCategoryRevenue()">
                    <div>ATO Withholdings</div>
                    <div class="align-right"></div>
                    <div class="align-right"></div>
                    <div class="align-right">{{ATOWithholdingsAmount | human:true}}</div>
                </div>
                <div class="row" (click)="switchCategoryRevenue()">
                    <div>Super Withholdings</div>
                    <div class="align-right"></div>
                    <div class="align-right"></div>
                    <div class="align-right">{{superWithholdingsAmount | human:true}}</div>
                </div>
            </div>
        </div>

        <div class="overview-panel" *ngIf="activeCategory=='overview'">

            <div class="table">
                <div class="header row">
                    <div></div>
                    <div class="align-right"></div>
                    <div class="align-right"></div>
                    <div class="align-right">Net Amount</div>
                </div>
                <div class="row" (click)="switchCategoryRevenue()">
                    <div>Revenue</div>
                    <div class="align-right"></div>
                    <div class="align-right"></div>
                    <div class="align-right">{{totalRevenueExcl | human:true}}</div>
                </div>

                <div class="row" (click)="switchCategoryExpense()">
                    <div>Expenses</div>
                    <div class="align-right"></div>
                    <div class="align-right"></div>
                    <div class="align-right">{{totalExpenseExcl | human:true}}</div>
                </div>

                <div class="row">
                    <div>Profit</div>
                    <div class="align-right"></div>
                    <div class="align-right"></div>
                    <div class="align-right">{{totalRevenueExcl-totalExpenseExcl | human:true}}</div>
                </div>

                <div class="header row">
                    <div>BAS</div>
                    <div class="align-right"></div>
                    <div class="align-right"></div>
                    <div class="align-right">Total</div>
                </div>
                <div class="row">
                    <div>Total Sales (G1)</div>
                    <div class="align-right"></div>
                    <div class="align-right"></div>
                    <div class="align-right">{{totalRevenueIncl | human:true}}</div>
                </div>
                <div class="row">
                    <div>GST on Sales (1A)</div>
                    <div class="align-right"></div>
                    <div class="align-right"></div>
                    <div class="align-right">{{gstOnSales | human:true}}</div>
                </div>
                <div class="row">
                    <div>GST on Expenses (1B)</div>
                    <div class="align-right"></div>
                    <div class="align-right"></div>
                    <div class="align-right">{{gstOnExpenses | human:true}}</div>
                </div>

                <div class="header row">
                    <div>Expenses</div>
                    <div class="align-right"></div>
                    <div class="align-right">GST</div>
                    <div class="align-right">Net Amount</div>
                </div>
                <div *ngFor="let category of atoCategorieTotals" class="row" (click)="switchCategoryExpense(category.category)">
                    <div class="">{{category.label}}</div>
                    <div class="align-right"></div>
                    <div class="align-right">{{category.vat | human:true}}</div>
                    <div class="align-right">{{category.netGST | human:true}}</div>
                </div>
            </div>
        </div>

        <div class="payroller-panel" *ngIf="activeCategory=='payroller-summary'">
            <div class="payroller-hero">
                <div>
                    <p class="eyebrow">Financial year</p>
                    <h2>Financial summary</h2>
                    <p>Record reported BAS values, payroll figures, and supporting documents for the financial year.</p>
                </div>
                <div class="period-card" *ngIf="getPayrollerFinancialYearRange() as fyRange; else payrollerPeriodUnavailable">
                    <span>Period</span>
                    <strong>{{fyRange.start | date:'dd MMM yyyy'}} - {{fyRange.end | date:'dd MMM yyyy'}}</strong>
                    <small>Locked to the financial year for the selected date range.</small>
                </div>
                <ng-template #payrollerPeriodUnavailable>
                    <div class="period-card warning">
                        <span>Period unavailable</span>
                        <strong>Choose a date range</strong>
                    </div>
                </ng-template>
            </div>

            <div class="payroller-warning" *ngIf="getPayrollerSummaryWarning()">
                <mat-icon>warning</mat-icon>
                <span>{{ getPayrollerSummaryWarning() }}</span>
            </div>

            <section class="payroller-card">
                <div class="section-heading">
                    <h3>Financial year notes</h3>
                    <p>General notes for this financial year. Existing payroll notes are migrated here when loaded.</p>
                </div>

                <mat-form-field appearance="outline" class="notes-field full-width">
                    <mat-label>Financial year notes</mat-label>
                    <textarea matInput rows="5" placeholder="Optional notes for this financial year" [(ngModel)]="financialSummaryNotes" (ngModelChange)="queuePayrollerSummarySave()" [disabled]="!isPayrollerSummaryAvailable() || isLoadingPayrollerSummary"></textarea>
                </mat-form-field>
            </section>

            <div class="payroller-grid" *ngIf="isPayrollerSummaryAvailable()">
                <section class="payroller-card bas-summary-card">
                    <div class="section-heading">
                        <div>
                            <h3>BAS reported values</h3>
                            <p>Enter lodged values by month or quarter. The yearly reported totals are calculated from these rows.</p>
                        </div>
                        <mat-form-field appearance="outline" class="bas-period-mode">
                            <mat-label>Entry period</mat-label>
                            <mat-select [value]="financialSummaryBas.periodMode" (selectionChange)="setBasPeriodMode($event.value)">
                                <mat-option *ngFor="let mode of basPeriodModes" [value]="mode.value">{{ mode.label }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="bas-summary-table">
                        <div class="bas-summary-row header">
                            <span>Period</span>
                            <span>Current G1</span>
                            <span>Reported G1</span>
                            <span>Current 1A</span>
                            <span>Reported 1A</span>
                            <span>Current 1B</span>
                            <span>Reported 1B</span>
                            <span>Report</span>
                        </div>
                        <div class="bas-summary-row" *ngFor="let period of financialSummaryBas.periods">
                            <span>{{ period.label }}</span>
                            <strong [class.bas-match]="isBasMatch(getBasPeriodCurrentTotal(period, 'totalSales'), period.totalSalesReported)">{{ getBasPeriodCurrentTotal(period, 'totalSales') | human:true }}</strong>
                            <ap-money [displayCents]="false" [outline]="true" [amount]="period.totalSalesReported" (amountChange)="updateBasPeriod(period, 'totalSalesReported', $event)"></ap-money>
                            <strong [class.bas-match]="isBasMatch(getBasPeriodCurrentTotal(period, 'gstOnSales'), period.gstOnSalesReported)">{{ getBasPeriodCurrentTotal(period, 'gstOnSales') | human:true }}</strong>
                            <ap-money [displayCents]="false"  [outline]="true" [amount]="period.gstOnSalesReported" (amountChange)="updateBasPeriod(period, 'gstOnSalesReported', $event)"></ap-money>
                            <strong [class.bas-match]="isBasMatch(getBasPeriodCurrentTotal(period, 'gstOnExpenses'), period.gstOnExpensesReported)">{{ getBasPeriodCurrentTotal(period, 'gstOnExpenses') | human:true }}</strong>
                            <ap-money [displayCents]="false" [outline]="true" [amount]="period.gstOnExpensesReported" (amountChange)="updateBasPeriod(period, 'gstOnExpensesReported', $event)"></ap-money>
                            <div class="bas-report-actions">
                                <a *ngIf="period.report" [href]="getFinancialYearReportUrl(period.report)" target="_blank" rel="noopener">Open</a>
                                <input #basReportInput type="file" accept="application/pdf" hidden (change)="uploadBasReport($event, period)">
                                <button type="button" mat-stroked-button (click)="basReportInput.click()" [disabled]="uploadingBasReportKey !== ''">
                                    {{ uploadingBasReportKey === period.periodKey ? 'Uploading...' : period.report ? 'Replace' : 'Upload' }}
                                </button>
                            </div>
                        </div>
                        <div class="bas-summary-row bas-summary-total">
                            <span>Financial year total</span>
                            <strong>{{ totalRevenueIncl | human:true }}</strong>
                            <strong>{{ getBasReportedTotal('totalSalesReported') | human:true }}</strong>
                            <strong>{{ gstOnSales | human:true }}</strong>
                            <strong>{{ getBasReportedTotal('gstOnSalesReported') | human:true }}</strong>
                            <strong>{{ gstOnExpenses | human:true }}</strong>
                            <strong>{{ getBasReportedTotal('gstOnExpensesReported') | human:true }}</strong>
                            <span></span>
                        </div>
                    </div>

                </section>

                <section class="payroller-card">
                    <div class="section-heading">
                        <h3>Manual payroll figures</h3>
                        <p>Figures are stored against {{ getPayrollerFinancialYearKey() || 'the selected financial year' }}.</p>
                    </div>

                    <div class="payroller-loading" *ngIf="isLoadingPayrollerSummary">Loading payroll summary...</div>

                    <div class="payroll-fields">
                        <div class="money-field">
                            <label>Wages paid</label>
                            <ap-money [outline]="true" [amount]="payrollerPayroll.wagesPaid" (amountChange)="payrollerPayroll.wagesPaid = $event || 0; queuePayrollerSummarySave()" [readonly]="!isPayrollerSummaryAvailable() || isLoadingPayrollerSummary"></ap-money>
                        </div>

                        <div class="money-field">
                            <label>PAYG tax paid</label>
                            <ap-money [outline]="true" [amount]="payrollerPayroll.paygTaxPaid" (amountChange)="payrollerPayroll.paygTaxPaid = $event || 0; queuePayrollerSummarySave()" [readonly]="!isPayrollerSummaryAvailable() || isLoadingPayrollerSummary"></ap-money>
                        </div>

                        <div class="money-field">
                            <label>Super paid</label>
                            <ap-money [outline]="true" [amount]="payrollerPayroll.superPaid" (amountChange)="payrollerPayroll.superPaid = $event || 0; queuePayrollerSummarySave()" [readonly]="!isPayrollerSummaryAvailable() || isLoadingPayrollerSummary"></ap-money>
                        </div>
                    </div>

                    <div class="payroller-actions">
                        <span class="save-message" *ngIf="payrollerSaveMessage">{{ payrollerSaveMessage }}</span>
                        <button type="button" mat-raised-button color="primary" (click)="savePayrollerSummary()" [disabled]="!isPayrollerSummaryAvailable() || isLoadingPayrollerSummary || isSavingPayrollerSummary">
                            {{ isSavingPayrollerSummary ? 'Saving...' : 'Save financial summary' }}
                        </button>
                    </div>
                </section>

                <section class="payroller-card">
                    <div class="section-heading">
                        <h3>Payroller PDF reports</h3>
                        <p>Upload targets for the reports that support the manually entered figures.</p>
                    </div>

                    <div class="report-upload-list">
                        <div class="report-upload-card" *ngFor="let reportType of payrollerReportTypes">
                            <mat-icon>picture_as_pdf</mat-icon>
                            <div>
                                <strong>{{ reportType.label }}</strong>
                                <ng-container *ngIf="getPayrollerReport(reportType.type) as report; else missingPayrollerReport">
                                    <span>{{ report.file.originalFilename || report.file.filename }}</span>
                                    <a [href]="getPayrollerReportUrl(report)" target="_blank" rel="noopener">Open PDF</a>
                                </ng-container>
                                <ng-template #missingPayrollerReport>
                                    <span>No PDF uploaded yet</span>
                                </ng-template>
                            </div>
                            <input #payrollerReportInput type="file" accept="application/pdf" hidden (change)="uploadPayrollerReport($event, reportType)">
                            <button type="button" mat-stroked-button (click)="payrollerReportInput.click()" [disabled]="uploadingPayrollerReportType !== ''">
                                {{ uploadingPayrollerReportType === reportType.type ? 'Uploading...' : getPayrollerReport(reportType.type) ? 'Replace' : 'Upload' }}
                            </button>
                        </div>
                    </div>
                </section>
            </div>
        </div>

        <!-- <div class="container">
            <mat-spinner></mat-spinner>
        </div> -->

        <ng-container *ngIf="dataSource.filteredData != undefined">
            <div class="no-records" *ngIf="dataSource?.filteredData.length == 0 && this.dataSource == null">
            No records 
            </div>
        </ng-container>

        <table class="transactions" mat-table [dataSource]="dataSource" multiTemplateDataRows>

            <ng-container matColumnDef="status">
                <th class="status-header" mat-header-cell *matHeaderCellDef>Status</th>
                <td class="status-column" mat-cell *matCellDef="let element">
                    <div class="status" [class]="element.status">{{element.status}}</div>
                </td>
            </ng-container>
        
            <ng-container matColumnDef="date">
                <th class="date" mat-header-cell *matHeaderCellDef>Date</th>
                <td class="date" mat-cell *matCellDef="let element"> {{element['date'] | date:'dd-MM-yy'}} </td>
            </ng-container>
        
            <ng-container matColumnDef="description">
                <th class="description" mat-header-cell *matHeaderCellDef>Description</th>
                <td mat-cell *matCellDef="let element">



                    <ng-container *ngIf="element.supplier != undefined">
                        <div class="fancy">
                            <span class="fancy-business">{{element.supplier.business}}</span>
                            <span *ngIf="element.supplier.date!=''" class="fancy-date">{{element.supplier.date}}</span>
                            <span *ngIf="element.supplier.order!=''" class="fancy-order">{{element.supplier.order}}</span>
                        </div>
                    </ng-container>


                    <ng-container *ngIf="element.supplier == undefined">
                        {{element['description']}}
                        <span class="note">{{element['note']}}</span>                        
                    </ng-container>
                </td>
            </ng-container>

            <ng-container matColumnDef="category">
                <th class="amount" mat-header-cell *matHeaderCellDef>Category</th>
                <td class="amount" mat-cell *matCellDef="let element">
                    {{ element['atocategory'] }}
                </td>
            </ng-container>
            
            <ng-container matColumnDef="amount">
                <th class="amount" mat-header-cell *matHeaderCellDef>Amount</th>
                <td class="amount" mat-cell *matCellDef="let element">
                    {{ element['amount'] | human }}
                    <ng-container *ngIf="element.amount > 0">Credit</ng-container>
                    <ng-container *ngIf="element.amount < 0">Debit</ng-container>
                </td>
            </ng-container>
        
            <ng-container matColumnDef="vat">
                <th class="vat" mat-header-cell *matHeaderCellDef>GST</th>
                <td class="vat" mat-cell *matCellDef="let element">
                    {{ element['vat'] | human }}
                </td>
            </ng-container>      

            <tr class="invoice-row"
                mat-row
                (click)="openTransactionDialog(element, i)"
                *matRowDef="let element; let i = dataIndex; columns: columnsToDisplay;">
            </tr>
        </table>
    </div>
</div>
